import React, { useState } from 'react';
import {
  Box,
  Button,
  TextField,
  Typography,
  Container,
} from '@mui/material';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const apiUrl = process.env.REACT_APP_API_URL;

const AddReproductionProcedure = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    procedure_name: '',
    description: '',
    default_price: '',
    is_active: true,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async () => {
    try {
      const userId = localStorage.getItem('userId');
      const payload = {
        ...formData,
        created_by: userId,
        created_at: new Date().toISOString().slice(0, 19).replace('T', ' '),
      };

      const response = await axios.post(
        `${apiUrl}/reproduction-clinic/procedures`,
        payload
      );

      if (response.status === 201) {
        alert('Procedure added successfully');
        navigate('/ReproductionProceduresList');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('Failed to add procedure');
    }
  };

  return (
    <Container maxWidth="sm">
      <Box mt={4}>
        <Typography variant="h4" mb={3}>
          Add Reproduction Procedure
        </Typography>

        <TextField
          fullWidth
          label="Procedure Name"
          name="procedure_name"
          value={formData.procedure_name}
          onChange={handleChange}
          margin="normal"
        />

        <TextField
          fullWidth
          label="Description"
          name="description"
          value={formData.description}
          onChange={handleChange}
          margin="normal"
          multiline
          rows={4}
        />

        <TextField
          fullWidth
          label="Default Price"
          name="default_price"
          type="number"
          value={formData.default_price}
          onChange={handleChange}
          margin="normal"
        />

        <Button
          variant="contained"
          color="primary"
          fullWidth
          sx={{ mt: 2 }}
          onClick={handleSubmit}
        >
          Submit
        </Button>
      </Box>
    </Container>
  );
};

export default AddReproductionProcedure;
